import { render, staticRenderFns } from "./BaseFile.vue?vue&type=template&id=55758d64&scoped=true"
import script from "./BaseFile.vue?vue&type=script&lang=js"
export * from "./BaseFile.vue?vue&type=script&lang=js"
import style0 from "./BaseFile.vue?vue&type=style&index=0&id=55758d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55758d64",
  null
  
)

export default component.exports